import styled from "styled-components";
import { BlogFeed } from "../../../../../common/others/blog/views/desktop/styled.js";
export const BlogContainer = styled.div.withConfig({
    displayName: "styled__BlogContainer",
    componentId: "sc-4088f23d-0"
})`
	${BlogFeed} {
		padding: 0 40px;
	}
`;

//# sourceMappingURL=styled.js.map